interface MessageStatusWarningProps {
  className?: string;
}

export default function MessageStatusWarning({
  className,
}: MessageStatusWarningProps) {
  return (
    <svg
      width="12"
      height="11"
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.44757 5.6281V8.6281M8.44757 11.6281H8.45507M7.40906 1.79689L1.24039 12.4519C0.898241 13.0429 0.727164 13.3383 0.752449 13.5809C0.774503 13.7924 0.885331 13.9846 1.05735 14.1097C1.25457 14.2531 1.59601 14.2531 2.27891 14.2531H14.6162C15.2991 14.2531 15.6406 14.2531 15.8378 14.1097C16.0098 13.9846 16.1206 13.7924 16.1427 13.5809C16.168 13.3383 15.9969 13.0429 15.6547 12.4519L9.48608 1.79689C9.14515 1.20802 8.97469 0.913585 8.75229 0.814695C8.5583 0.728435 8.33684 0.728435 8.14285 0.814695C7.92045 0.913585 7.74999 1.20802 7.40906 1.79689Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
